module.exports = __webpack_public_path__ + "img/白酒行业结构示意图.ddcedda9.jpg";